import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var typePreparation = function typePreparation(currentType, hidePasswordProp, maskProp) {
  var outputType;
  switch (currentType) {
    case 'csc':
      outputType = 'password';
      break;
    case 'password':
      outputType = hidePasswordProp ? 'password' : 'text';
      break;
    case 'date':
      outputType = 'date';
      break;
    default:
      if (maskProp) {
        outputType = 'tel';
      } else {
        outputType = currentType;
      }
  }
  return outputType;
};
export var toggleClickFunc = function toggleClickFunc(type, value, clearable, toggleHidePassword, clear, emptyCallback) {
  // eslint-disable-line
  if (type === 'password') {
    return toggleHidePassword;
  } else if (type === 'search' && !value) {
    return emptyCallback;
  } else if (value && (type === 'search' || clearable)) {
    return clear;
  }
  return emptyCallback;
};
export var toggleButtonTitle = function toggleButtonTitle(type, value, clearable, hidePassword) {
  if (type === 'password') {
    return hidePassword ? 'Показать пароль' : 'Скрыть пароль';
  } else if (type === 'search' && !value) {
    return 'Искать';
  } else if (value && (type === 'search' || clearable)) {
    return 'Очистить';
  }
  return false;
};
export var filterInputProps = function filterInputProps(onChangeFunc, actualType, notAllowedProps) {
  var outputProps = _objectSpread({}, arguments.length <= 3 ? undefined : arguments[3]);
  Object.keys(outputProps).filter(function (key) {
    return notAllowedProps.includes(key);
  }).forEach(function (key) {
    return delete outputProps[key];
  });
  if (outputProps.autoComplete) {
    var type = outputProps.type;
    var autoComplete = outputProps.autoComplete;
    outputProps.autoComplete = type === 'csc' || type === 'password' ? 'off' : autoComplete;
  }
  outputProps.type = actualType;
  outputProps.onChange = onChangeFunc;
  return outputProps;
};